export default __webpack_public_path__ + "static/media/logo-troyameancreative.b3ff1d0f.svg";